/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineOrderService() {
        let orderService = {};
        orderService.getOrdersForDelivery = function (request){
            return axios.post("/api/OrderService/GetOrdersForDelivery", request);
        };
        orderService.getOrderForDelivery = function (orderId, orderDeliveryId){
            return axios.get("/api/OrderService/GetOrderForDelivery?orderId=" + orderId + "&orderDeliveryId=" + orderDeliveryId);
        };
        orderService.getCollectionOrders = function (request){
            return axios.post("/api/OrderService/GetCollectionOrders", request);
        };
        orderService.getCollectionOrder = function (orderCollectionId){
            return axios.get("/api/OrderService/GetCollectionOrder?orderCollectionId=" + orderCollectionId);
        };
        orderService.getOrderItemsForOrder = function (orderId){
            return axios.get("/api/OrderService/GetOrderItemsForOrder?orderId=" + orderId);
        };
        orderService.getOrderStatuses = function (){
            return [
                {
                    orderStatusId: orderHelper.orderStatus.accepted,
                    description: "Accepted"
                },
                {
                    orderStatusId: orderHelper.orderStatus.complete,
                    description: "Complete"
                },
                {
                    orderStatusId: orderHelper.orderStatus.pending,
                    description: "Pending"
                },
                {
                    orderStatusId: orderHelper.orderStatus.rejected,
                    description: "Rejected"
                },
                {
                    orderStatusId: orderHelper.orderStatus.readyForCollection,
                    description: "Ready For Collection"
                },
                {
                    orderStatusId: orderHelper.orderStatus.scheduledDeliveryCancelled,
                    description: "Scheduled For Delivery Cancelled"
                },
                {
                    orderStatusId: orderHelper.orderStatus.scheduledForDelivery,
                    description: "Scheduled For Delivery"
                },
                // {
                //     orderStatusId: orderHelper.orderStatus.onDelivery,
                //     description: "On Delivery"
                // },
                {
                    orderStatusId: orderHelper.orderStatus.cancelled,
                    description: "Cancelled"
                },
                {
                    orderStatusId: orderHelper.orderStatus.pendingInvoice,
                    description: "Pending Invoice"
                }
            ];
        };
        orderService.getCollectionOrderStatues = function () {
            return [
                {
                    orderStatusId: orderHelper.orderStatus.readyForCollection,
                    description: "Ready For Collection"
                },
                {
                    orderStatusId: orderHelper.orderStatus.complete,
                    description: "Complete"
                },
                {
                    orderStatusId: orderHelper.orderStatus.cancelled,
                    description: "Cancelled"
                },
                {
                    orderStatusId: orderHelper.orderStatus.pendingInvoice,
                    description: "Pending Invoice"
                }
            ];
        };
        orderService.getExTankOrderStatuses = function (){
            return [
                {
                    orderStatusId: orderHelper.orderStatus.pending,
                    description: "Pending"
                },
                {
                    orderStatusId: orderHelper.orderStatus.accepted,
                    description: "Accepted"
                },
                {
                    orderStatusId: orderHelper.orderStatus.rejected,
                    description: "Rejected"
                },
                {
                    orderStatusId: orderHelper.orderStatus.readyForUpliftment,
                    description: "Ready For Upliftment"
                },
                {
                    orderStatusId: orderHelper.orderStatus.uplifted,
                    description: "Uplifted"
                },
                {
                    orderStatusId: orderHelper.orderStatus.complete,
                    description: "Complete"
                },
                {
                    orderStatusId: orderHelper.orderStatus.cancelled,
                    description: "Cancelled"
                },
                {
                    orderStatusId: orderHelper.orderStatus.pendingInvoice,
                    description: "Pending Invoice"
                }
            ];
        };
        orderService.getDeliveryOrderStatuses = function () {
            // TODO: get from api
            return [
                {
                    orderStatusId: orderHelper.orderStatus.pending,
                    description: "Pending"
                },
                {
                    orderStatusId: orderHelper.orderStatus.accepted,
                    description: "Accepted"
                },
                {
                    orderStatusId: orderHelper.orderStatus.rejected,
                    description: "Rejected"
                },
                {
                    orderStatusId: orderHelper.orderStatus.scheduledForDelivery,
                    description: "Scheduled For Delivery"
                },
                // {
                //     orderStatusId: orderHelper.orderStatus.onDelivery,
                //     description: "On Delivery"
                // },
                {
                    orderStatusId: orderHelper.orderStatus.scheduledDeliveryCancelled,
                    description: "Scheduled For Delivery Cancelled"
                },
                {
                    orderStatusId: orderHelper.orderStatus.complete,
                    description: "Complete"
                },
                {
                    orderStatusId: orderHelper.orderStatus.cancelled,
                    description: "Cancelled"
                },
                {
                    orderStatusId: orderHelper.orderStatus.pendingInvoice,
                    description: "Pending Invoice"
                }
            ];
        };
        orderService.getOrderTypes = function (){
            return [
                {
                    orderTypeId: orderHelper.orderType.delivery,
                    description: "Delivery"
                },
                {
                    orderTypeId: orderHelper.orderType.collection,
                    description: "Collection"
                },
                {
                    orderTypeId: orderHelper.orderType.exTank,
                    description: "Ex-Tank"
                }
            ];
        };
        orderService.getProducts = function (){
            let products = [
                {
                    productId: 1,
                    name: "Diesel(500ppm)",
                    price: 12,
                    erpCode: "Diesel500",
                    isActive: true,
                    insertedOn: new Date(),
                    allowCollection: true,
                    allowDelivery: true,
                    discountedAmount: 0
                },
                {
                    productId: 2,
                    name: "Diesel(50ppm)",
                    price: 12,
                    erpCode: "Diesel50",
                    isActive: true,
                    insertedOn: new Date(),
                    allowCollection: false,
                    allowDelivery: true,
                    discountedAmount: 0
                }
            ];
            products = dataTableHelper.castFieldValues(products);
            return products;
        };
        orderService.addOrUpdateDeliveryOrder = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateDeliveryOrder", request);
        };
        orderService.addOrUpdateCollectionOrder = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateCollectionOrder", request);
        };
        orderService.acceptOrRejectDeliveryOrder = function (request) {
            return axios.post("/api/OrderService/AcceptOrRejectDeliveryOrder", request);
        };
        orderService.acceptOrRejectOrder = function (request) {
            return axios.post("/api/OrderService/AcceptOrRejectOrder", request);
        };
        orderService.scheduleOrderForDelivery = function (request) {
            return axios.post("/api/OrderService/ScheduleOrderForDelivery", request);
        };
        orderService.getOrderTransactionHistoryForOrder = function (orderId){
            return axios.get("/api/OrderService/GetOrderTransactionHistoryForOrder?orderId=" + orderId);
        };
        orderService.getOrderDeliverySchedule = function (orderDeliveryScheduleId, orderDeliveryId){
            return axios.get("/api/OrderService/GetOrderDeliverySchedule?orderDeliveryScheduleId=" + orderDeliveryScheduleId + "&orderDeliveryId=" + orderDeliveryId);
        };
        orderService.updateOrderStatus = function (request) {
            return axios.post("/api/OrderService/UpdateOrderStatus", request);
        };
        orderService.getFailedReasons = function (request) {
            return axios.post("/api/OrderService/GetFailedReasons", request);
        };
        orderService.getFailedReason = function (failedReasonId){
            return axios.get("/api/OrderService/GetFailedReason?failedReasonId=" + failedReasonId);
        };
        orderService.addOrUpdateFailedReason = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateFailedReason", request);
        };
        orderService.markFailedReasonAsActiveOrInactive = function (request) {
            return axios.post("/api/OrderService/MarkFailedReasonAsActiveOrInactive", request);
        };
        orderService.cancelOrder = function (request) {
            return axios.post("/api/OrderService/CancelOrder", request);
        };
        orderService.getTrackingHistoriesForOrder = function (orderId){
            return axios.get("/api/OrderService/GetTrackingHistoriesForOrder?orderId=" + orderId);
        };
        orderService.getCompanyProductPricesByShippingAddress = function (request) {
            return axios.post("/api/OrderService/GetCompanyProductPricesByShippingAddress", request);
        };
        orderService.getOrderDeliveryAsPdf = function (orderId, orderDeliveryId) {
            var win = window.open("/api/OrderService/GetOrderDeliveryAsPdf?orderId=" + orderId + "&orderDeliveryId=" + orderDeliveryId, "_blank");
            if (win) {
                win.focus();
            } else {
                alert('Please allow popups for this website');
            }
            //return axios.get("/api/OrderService/GetOrderDeliveryAsPdf?orderId=" + orderId + "&orderDeliveryId=" + orderDeliveryId, { responseType: "blob" });
        };
        orderService.getOrderCollectionAsPdf = function (orderId, orderCollectionId) {
            var win = window.open("/api/OrderService/GetOrderCollectionAsPdf?orderId=" + orderId + "&orderCollectionId=" + orderCollectionId, "_blank");
            if (win) {
                win.focus();
            } else {
                alert('Please allow popups for this website');
            }
            //return axios.get("/api/OrderService/GetOrderCollectionAsPdf?orderId=" + orderId + "&orderCollectionId=" + orderCollectionId, { responseType: "blob" });
        };
        // orderService.getFailedReasonForOrderDeliverySchedule = function (orderDeliveryScheduleId){
        //     return axios.get("/api/OrderService/GetFailedReasonForOrderDeliverySchedule?orderDeliveryScheduleId=" + orderDeliveryScheduleId);
        // };
        orderService.getFailedReasonForOrderDelivery = function (orderDeliveryId){
            return axios.get("/api/OrderService/GetFailedReasonForOrderDelivery?orderDeliveryId=" + orderDeliveryId);
        };
        orderService.cancelCollectionOrder = function (request) {
            return axios.post("/api/OrderService/CancelCollectionOrder", request);
        };
        orderService.cancelDeliveryOrder = function (request) {
            return axios.post("/api/OrderService/CancelDeliveryOrder", request);
        };
        orderService.cancelOrderScheduledForDelivery = function (request) {
            return axios.post("/api/OrderService/CancelOrderScheduledForDelivery", request);
        };
        orderService.markDeliveryOrderAsOnDelivery = function (request) {
            return axios.post("/api/OrderService/MarkDeliveryOrderAsOnDelivery", request);
        };
        orderService.markDeliveryOrderAsInPendingInvoice = function (request) {
            return axios.post("/api/OrderService/MarkDeliveryOrderAsInPendingInvoice", request);
        };
        orderService.completeDeliveryOrder = function (request) {
            return axios.post("/api/OrderService/CompleteDeliveryOrder", request); 
        };
        orderService.getDepotProductPrices = function (request) {
            return axios.post("/api/OrderService/GetDepotProductPrices", request);
        };
        orderService.getDepotAdditionalServicesAndProductsPrices = function (request) {
            return axios.post("/api/OrderService/GetDepotAdditionalServicesAndProductsPrices", request);
        };
        orderService.getDepotProductPrice = function (depotProductPriceId){
            return axios.get("/api/OrderService/GetDepotProductPrice?depotProductPriceId=" + depotProductPriceId);
        };
        orderService.addOrUpdateDepotProductPrice = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateDepotProductPrice", request);
        };
        orderService.addOrUpdateDepotProductPrices = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateDepotProductPrices", request);
        };
        orderService.markDepotProductPriceAsActiveOrInactive = function (request) {
            return axios.post("/api/OrderService/MarkDepotProductPriceAsActiveOrInactive", request);
        };
        orderService.getDiscountGroups = function (request) {
            return axios.post("/api/OrderService/GetDiscountGroups", request);
        };
        orderService.getDiscountGroup = function (discountGroupId){
            return axios.get("/api/OrderService/GetDiscountGroup?discountGroupId=" + discountGroupId);
        };
        orderService.addOrUpdateDiscountGroup = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateDiscountGroup", request);
        };
        orderService.markDiscountGroupAsActiveOrInactive = function (request) {
            return axios.post("/api/OrderService/MarkDiscountGroupAsActiveOrInactive", request);
        };
        orderService.linkAndUnlinkProductsFromDiscountGroup = function (request) {
            return axios.post("/api/OrderService/LinkAndUnlinkProductsFromDiscountGroup", request);
        };
        orderService.getDiscountGroupProductsByDiscountGroup = function (discountGroupId) {
            return axios.get("/api/OrderService/GetDiscountGroupProductsByDiscountGroup?discountGroupId=" + discountGroupId);
        };
        orderService.getDiscountGroupCompaniesByDiscountGroup = function (discountGroupId) {
            return axios.get("/api/OrderService/GetDiscountGroupCompaniesByDiscountGroup?discountGroupId=" + discountGroupId);
        };
        orderService.linkAndUnlinkCompaniesFromDiscountGroup = function (request) {
            return axios.post("/api/OrderService/LinkAndUnlinkCompaniesFromDiscountGroup", request);
        };
        orderService.getProductsForDiscountGroup = function (discountGroupId, searchQuery) {
            if(searchQuery === null || searchQuery === undefined){
                return axios.get("/api/OrderService/GetProductsForDiscountGroup?discountGroupId=" + discountGroupId);
            }
            return axios.get("/api/OrderService/GetProductsForDiscountGroup?discountGroupId=" + discountGroupId + "&searchQuery=" + searchQuery);
        };
        orderService.getCompaniesLinkedToDiscountGroup = function(request){
            return axios.post("/api/OrderService/GetCompaniesLinkedToDiscountGroup", request);
        };
        orderService.getCompaniesUnlinkedToDiscountGroup = function(request){
            return axios.post("/api/OrderService/GetCompaniesUnlinkedToDiscountGroup", request);
        };
        orderService.getCompaniesLinkedAndUnlinkedToDiscountGroup = function (discountGroupId, pageNumber, pageSize, searchQuery) {
            if(searchQuery === null || searchQuery === undefined){
                return axios.get("/api/OrderService/GetCompaniesLinkedAndUnlinkedToDiscountGroup?discountGroupId=" + discountGroupId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize);
            }
            return axios.get("/api/OrderService/GetCompaniesLinkedAndUnlinkedToDiscountGroup?discountGroupId=" + discountGroupId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&searchQuery=" + searchQuery);
        };
        orderService.getComboDiscountGroups = function (request) {
            return axios.post("/api/OrderService/GetComboDiscountGroups", request);
        };
        orderService.getComboDiscountGroup = function (comboDiscountGroupId){
            return axios.get("/api/OrderService/GetComboDiscountGroup?comboDiscountGroupId=" + comboDiscountGroupId);
        };
        orderService.addOrUpdateComboDiscountGroup = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateComboDiscountGroup", request);
        };
        orderService.markComboDiscountGroupAsActiveOrInactive = function (request) {
            return axios.post("/api/OrderService/MarkComboDiscountGroupAsActiveOrInactive", request);
        };
        orderService.getComboDiscountGroupProductsByComboDiscountGroup = function (comboDiscountGroupId) {
            return axios.get("/api/OrderService/GetComboDiscountGroupProductsByComboDiscountGroup?comboDiscountGroupId=" + comboDiscountGroupId);
        };
        orderService.linkAndUnlinkProductsFromComboDiscountGroup = function (request) {
            return axios.post("/api/OrderService/LinkAndUnlinkProductsFromComboDiscountGroup", request);
        };
        orderService.getProductsForComboDiscountGroup = function (comboDiscountGroupId, searchQuery) {
            return axios.post("/api/OrderService/GetProductsForComboDiscountGroup", {
                comboDiscountGroupId: comboDiscountGroupId,
                searchQuery: searchQuery
            });
        };
        orderService.getDepotDiscountGroups = function (request) {
            return axios.post("/api/OrderService/GetDepotDiscountGroups", request);
        };
        orderService.getDepotDiscountGroup = function (depotDiscountGroupId){
            return axios.get("/api/OrderService/GetDepotDiscountGroup?depotDiscountGroupId=" + depotDiscountGroupId);
        };
        orderService.addOrUpdateDepotDiscountGroup = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateDepotDiscountGroup", request);
        };
        orderService.markDepotDiscountGroupAsActiveOrInactive = function (request) {
            return axios.post("/api/OrderService/MarkDepotDiscountGroupAsActiveOrInactive", request);
        };
        orderService.getDepotDiscountGroupProductsByDepotDiscountGroup = function (depotDiscountGroupId) {
            return axios.get("/api/OrderService/GetDepotDiscountGroupProductsByDepotDiscountGroup?depotDiscountGroupId=" + depotDiscountGroupId);
        };
        orderService.getProductsForDepotDiscountGroup = function (depotDiscountGroupId, depotId, searchQuery) {
            if(searchQuery === null || searchQuery === undefined){
                return axios.get("/api/OrderService/GetProductsForDepotDiscountGroup?depotDiscountGroupId=" + depotDiscountGroupId + "&depotId=" + depotId);
            }
            return axios.get("/api/OrderService/GetProductsForDepotDiscountGroup?depotDiscountGroupId=" + depotDiscountGroupId + "&depotId=" + depotId + "&searchQuery=" + searchQuery);
        };
        orderService.getDepotDiscountGroupCompaniesByDepotDiscountGroup = function (depotDiscountGroupId) {
            return axios.get("/api/OrderService/GetDepotDiscountGroupCompaniesByDepotDiscountGroup?depotDiscountGroupId=" + depotDiscountGroupId);
        };
        orderService.getCompaniesLinkedAndUnlinkedToDepotDiscountGroup = function (depotDiscountGroupId, pageNumber, pageSize, searchQuery) {
            if(searchQuery === null || searchQuery === undefined){
                return axios.get("/api/OrderService/GetCompaniesLinkedAndUnlinkedToDepotDiscountGroup?depotDiscountGroupId=" + depotDiscountGroupId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize);
            }
            return axios.get("/api/OrderService/GetCompaniesLinkedAndUnlinkedToDepotDiscountGroup?depotDiscountGroupId=" + depotDiscountGroupId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&searchQuery=" + searchQuery);
        };
        orderService.getCompaniesLinkedToDepotDiscountGroup = function(request){
            return axios.post("/api/OrderService/GetCompaniesLinkedToDepotDiscountGroup", request);
        };
        orderService.getCompaniesUnlinkedToDepotDiscountGroup = function(request){
            return axios.post("/api/OrderService/GetCompaniesUnlinkedToDepotDiscountGroup", request);
        };
        orderService.linkAndUnlinkProductsFromDepotDiscountGroup = function (request) {
            return axios.post("/api/OrderService/LinkAndUnlinkProductsFromDepotDiscountGroup", request);
        };
        orderService.linkAndUnlinkCompaniesFromDepotDiscountGroup = function (request) {
            return axios.post("/api/OrderService/LinkAndUnlinkCompaniesFromDepotDiscountGroup", request);
        };
        orderService.markCollectionOrderAsInPendingInvoice = function (request) {
            return axios.post("/api/OrderService/MarkCollectionOrderAsInPendingInvoice", request);
        };
        orderService.completeCollectionOrder = function (request) {
            return axios.post("/api/OrderService/CompleteCollectionOrder", request);
        };
        orderService.getOrderCollectionProductPricesForDepot = function (request) {
            return axios.post("/api/OrderService/GetOrderCollectionProductPricesForDepot", request);
        };
        orderService.getDiscountForCompanyAndProduct = function (request) {
            return axios.post("/api/OrderService/GetDiscountForCompanyAndProduct", request);
        };
        orderService.verifyOrderCollectionByCollectionCode = function (request) {
            return axios.post("/api/OrderService/VerifyOrderCollectionByCollectionCode", request);
        };
        orderService.getOrderDispensedForOrder = function (orderId) {
            return axios.get("/api/OrderService/GetOrderDispensedForOrder?orderId=" + orderId);
        };
        orderService.getDeliveryOrdersAsExcelDocument = function (request) {
            return axios.post("/api/OrderService/GetDeliveryOrdersAsExcelDocument", request, { responseType: 'blob' });
        };
        orderService.getCollectionOrdersAsExcelDocument = function (request) {
            return axios.post("/api/OrderService/GetCollectionOrdersAsExcelDocument", request, { responseType: 'blob' });
        };
        orderService.getOrderScheduleAsPdf = function (orderId, orderDeliveryId) {
            var win = window.open("/api/OrderService/GetOrderScheduleAsPdf?orderId=" + orderId + "&orderDeliveryId=" + orderDeliveryId, "_blank");
            if (win) {
                win.focus();
            } else {
                alert('Please allow popups for this website');
            }
        };
        orderService.getSpecialPricingMethods = function (orderTypeId) {
            if(orderTypeId === orderHelper.orderType.delivery || orderTypeId === orderHelper.orderType.exTank){
                return [
                    {
                        specialPricingMethodId: orderHelper.specialPricingMethod.customerPricingPerZone,
                        description: "Customer Pricing Per Zone"
                    }
                ];
            }
            if(orderTypeId === orderHelper.orderType.collection){
                return [
                    {
                        specialPricingMethodId: orderHelper.specialPricingMethod.discountGroups,
                        description: "Discount Groups"
                    },
                    {
                        specialPricingMethodId: orderHelper.specialPricingMethod.depotDiscountGroups,
                        description: "Depot Discount Groups"
                    }
                ];
            }
        };
        orderService.getDepotDiscountGroupsForCompany = function (request) {
            return axios.post("/api/OrderService/GetDepotDiscountGroupsForCompany", request);
        };
        orderService.getDiscountGroupsForCompany = function (request) {
            return axios.post("/api/OrderService/GetDiscountGroupsForCompany", request);
        };
        orderService.linkDiscountGroupsToCompany = function (request) {
            return axios.post("/api/OrderService/LinkDiscountGroupsToCompany", request);
        };
        orderService.linkDepotDiscountGroupsToCompany = function (request) {
            return axios.post("/api/OrderService/LinkDepotDiscountGroupsToCompany", request);
        };
        orderService.getDeliveryOrdersForScheduling = function (pageNumber, pageSize, expectedDateOfDelivery){
            return axios.get("/api/OrderService/GetDeliveryOrdersForScheduling?pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&expectedDateOfDelivery=" + expectedDateOfDelivery);
        };
        orderService.getOrderItemsAssignedCompartments = function (request) {
            return axios.post("/api/OrderService/GetOrderItemsAssignedCompartments", request);
        };
        orderService.getOrderDeliveryVehicleCompartmentProductsSummaryForOrderDelivery = function (request) {
            return axios.post("/api/OrderService/GetOrderDeliveryVehicleCompartmentProductsSummaryForOrderDelivery", request);
        };
        orderService.getVehicleCompartmentProductsForOrderAssignment = function (request) {
            return axios.post("/api/OrderService/GetVehicleCompartmentProductsForOrderAssignment", request);
        };
        orderService.addOrUpdateOrderDeliverySchedule = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateOrderDeliverySchedule", request);
        };
        orderService.getOrderDeliveryScheduleSboHistory = function (orderDeliveryId){
            return axios.get("/api/OrderService/GetOrderDeliveryScheduleSboHistory?orderDeliveryId=" + orderDeliveryId);
        };
        orderService.updateOrderDeliveryScheduleSbo = function (request) {
            return axios.post("/api/OrderService/UpdateOrderDeliveryScheduleSbo", request);
        };
        orderService.getDeliveryOrdersByVehicleIdAndExpectedDeliveryDate = function (request) {
            return axios.post("/api/OrderService/GetDeliveryOrdersByVehicleIdAndExpectedDeliveryDate", request);
        };
        orderService.updateSequenceNumberForOrderDeliveries = function (request) {
            return axios.post("/api/OrderService/UpdateSequenceNumberForOrderDeliveries", request);
        };
        orderService.cancelOrderDeliverySchedule = function (request) {
            return axios.post("/api/OrderService/CancelOrderDeliverySchedule", request);
        };
        orderService.getDeliveryOrderScheduleSummary = function (orderDeliveryScheduleId){
            return axios.get("/api/OrderService/GetDeliveryOrderScheduleSummary?orderDeliveryScheduleId=" + orderDeliveryScheduleId);
        };
        orderService.getOrderChecklistsForCollectionOrders = function (){
            return axios.get("/api/OrderService/GetOrderChecklistsForCollectionOrders");
        };
        orderService.markOrderChecklistsAsActiveOrInactive = function (request) {
            return axios.post("/api/OrderService/MarkOrderChecklistsAsActiveOrInactive", request);
        };
        orderService.rescheduleDeliveryBatch = function (request) {
            return axios.post("/api/OrderService/RescheduleDeliveryBatch", request);
        };
        orderService.getDocumentsByOrderId = function (orderId){
            return axios.get("/api/OrderService/GetDocumentsByOrderId?orderId=" + orderId);
        };
        orderService.downloadOrderDocument = function (request){
            return axios.post("/api/OrderService/DownloadOrderDocument", request, { responseType: 'blob' });
            // var win = window.open("/api/OrderService/DownloadOrderDocument?pathToFileStorage=" + pathToFileStorage + "&fileName=" + fileName, "_blank");
            // if (win) {
            //     win.focus();
            // } else {
            //     alert('Please allow popups for this website');
            // }
            //return axios.get("/api/OrderService/GetOrderDocument?pathToFileStorage=" + pathToFileStorage + "&fileName=" + fileName, { responseType: "blob" });
        };
        orderService.getDocumentTypesByOrderTypeId = function (orderTypeId){
            return axios.get("/api/OrderService/GetDocumentTypesByOrderTypeId?orderTypeId=" + orderTypeId);
        };
        orderService.addOrUpdateDocument = function (formData){
            return axios.post("/api/OrderService/AddOrUpdateDocument", formData, { headers: {'Content-Type': 'multipart/form-data' }});
        };
        orderService.getMonthlyBatchedDocumentsByCompanyId = function (request){
            return axios.post("/api/OrderService/GetMonthlyBatchedDocumentsByCompanyId", request);
        };
        orderService.getOrderEnquiryMessagesByOrderId = function (orderId, pageNumber, pageSize){
            return axios.get("/api/OrderService/GetOrderEnquiryMessagesByOrderId?orderId=" + orderId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize);
        };
        orderService.addOrUpdateOrderEnquiryMessage = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateOrderEnquiryMessage", request);
        };
        orderService.getDatesForCustomerBatchedDocuments = function (startDate, endDate){
            return axios.get("/api/OrderService/GetDatesForCustomerBatchedDocuments?startDate=" + startDate + "&endDate=" + endDate);
        };
        orderService.downloadReportCollectionVolumeDispensed = function (request){
            return axios.post("/api/OrderService/DownloadReportCollectionVolumeDispensed", request, { responseType: 'blob' });
        };
        orderService.downloadReportDeliveryVarianceReport = function (request){
            return axios.post("/api/OrderService/DownloadReportDeliveryVarianceReport", request, { responseType: 'blob' });
        };
        orderService.downloadReportExTankDispenseVarianceReport = function (request){
            return axios.post("/api/OrderService/DownloadReportExTankDispenseVarianceReport", request, { responseType: 'blob' });
        };
        orderService.checkReportCollectionVolumeDispensed = function (request){
            return axios.post("/api/OrderService/CheckReportCollectionVolumeDispensed", request);
        };
        orderService.checkReportDeliveryVarianceReport = function (request){
            return axios.post("/api/OrderService/CheckReportDeliveryVarianceReport", request);
        };
        orderService.checkReportExTankDispenseVarianceReport = function (request){
            return axios.post("/api/OrderService/CheckReportExTankDispenseVarianceReport", request);
        };
        orderService.getPricingReport = function (request){
            return axios.post("/api/OrderService/GetPricingReport", request, { responseType: 'blob' });
        };
        orderService.reportVolumePerDepotByDateRange = function (request){
            return axios.post("/api/OrderService/ReportVolumePerDepotByDateRange", request);
        };
        orderService.downloadReportVolumePerDepotByDateRange = function (request){
            return axios.post("/api/OrderService/DownloadReportVolumePerDepotByDateRange", request, { responseType: 'blob' });
        };
        orderService.downloadVolumeByCustomerDepotShippingAddress = function (request){
            return axios.post("/api/OrderService/DownloadVolumeByCustomerDepotShippingAddress", request, { responseType: 'blob' });
        };
        return orderService;
    }
    //define globally if it doesn't already exist
    if (typeof (orderService) === "undefined") {
        window.orderService = defineOrderService();
    } else {
        console.log("orderService already defined.");
    }
})(window);